import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { delay } from 'rxjs';

import { TitleService } from '@ecm/router';

import { MenuStoreService } from '../../store/menu-store.service';

@Component({
    selector: 'ecm-orange-menu',
    templateUrl: 'orange-menu.html',
    styleUrls: ['orange-menu.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgTemplateOutlet, RouterLink, AsyncPipe, TranslateModule],
})
export class OrangeMenuComponent implements OnInit, OnDestroy {
    public showBack$ = this.menuStore.showBack$.pipe(delay(0));
    public title$ = this.titleService.getTitle().pipe(delay(0));

    public constructor(
        private menuStore: MenuStoreService,
        private titleService: TitleService,
    ) {}

    public ngOnInit(): void {
        this.menuStore.enter();
    }

    public ngOnDestroy(): void {
        this.menuStore.leave();
    }

    public navigateToBackRoute(): void {
        this.menuStore.navigateToBackRoute();
    }
}
